import React from 'react';
import SectionCard from './SectionCard';
import { projectsData, engagementsData } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const ProjectsSection = ({ isDoorOpen }) => {
  const { t, language } = useLanguage();

  // Get data for current language
  const projects = projectsData[language] || projectsData.fr;
  const engagements = engagementsData[language] || engagementsData.fr;

  return (
    <SectionCard
      id="projets"
      icon="💡"
      title={t.projects.title}
      subtitle={t.projects.subtitle}
      isDoorOpen={isDoorOpen}
    >
      {projects.map((project) => (
        <div key={project.id} className="exp-item">
          <div className="exp-title">{project.title}</div>
          <div className="exp-meta">{project.year}</div>
          <p>{project.description}</p>
          {project.url && (
            <a 
              href={project.url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="project-link"
            >
              🔗 {project.url}
            </a>
          )}
        </div>
      ))}

      <div className="exp-item">
        <div className="exp-title">{t.projects.engagements}</div>
        <ul>
          {engagements.map((engagement) => (
            <li key={engagement.id}>
              {engagement.title}
              {engagement.description && ` (${engagement.description})`}
            </li>
          ))}
        </ul>
      </div>
    </SectionCard>
  );
};

export default ProjectsSection;
